import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Veritux ERP — Sistema com PDV para loja: vendas no balcão, estoque e faturamento integrados | Mais controle. Mais lucros. Mais futuro.',
  description = 'O Veritux ERP entrega controle total, insights em tempo real e crescimento previsível. Sistema completo de gestão para pequenas e médias empresas. Teste grátis por 15 dias.',
  keywords = 'ERP, sistema ERP, gestão empresarial, sistema de gestão, controle de estoque, gestão financeira, produção de vestuário, ERP para Windows, ERP Brasil, software de gestão, gestão de vendas, NF-e, automação empresarial',
  image = '/og-image.jpg',
  url = 'https://www.veritux.com.br',
  type = 'website',
  structuredData = null
}) => {
  const fullTitle = title.includes('Veritux') ? title : `${title} | Veritux ERP`;
  const fullUrl = url.startsWith('http') ? url : `https://www.veritux.com.br${url}`;
  const fullImage = image.startsWith('http') ? image : `https://www.veritux.com.br${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Veritux ERP" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="Portuguese" />
      <meta name="revisit-after" content="7 days" />
      <meta name="rating" content="general" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:site_name" content="Veritux ERP" />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:image:alt" content={fullTitle} />
      <meta name="twitter:creator" content="@veritux" />
      <meta name="twitter:site" content="@veritux" />

      {/* Additional SEO */}
      <meta name="geo.region" content="BR" />
      <meta name="geo.placename" content="Brasil" />
      <meta name="theme-color" content="#0F1E3C" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="Veritux ERP" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
